<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">Número</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">Marca</th>
        <th scope="col" class="border-0 text-center">À vista</th>
        <th scope="col" class="border-0 text-center">À prazo</th>
        <th scope="col" class="border-0 text-center">Total</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in reports" :key="index" class="align-items-center">
        <td class="td-1">{{ row.id }}</td>
        <td class="td-5 link">{{ row.name }}</td>
        <td class="td-2">{{ row.brand }}</td>
        <td class="td-1 text-right">{{ row.total_term }}</td>
        <td class="td-1 text-right">{{ row.total_cash }}</td>
        <td class="td-1 text-right">{{ row.grand_total }}</td>
      </tr>
      <tr v-if="reports.length === 0">
        <td colspan="6" class="no-content">Ainda não tem resultado.</td>
      </tr>
    </tbody>
    <!-- <import-modals/> -->
  </table>
</template>

<script>

export default {
  name: 'report-product-table',
  components: {
  },
  props: {
    reports: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

</style>
